import { atomWithMutation } from 'jotai-tanstack-query';
import { isAxiosError } from 'axios';

import { instance } from '@/interfaces';

import type { APIResponse } from '@/@types/types';

export const postOrderInfoAtom = atomWithMutation(() => ({
  mutationFn: async ({ orderId, amount }: { orderId: string; amount: number }) => {
    const isSuccess = await postOrderInfo(orderId, amount);
    return isSuccess;
  },
}));
async function postOrderInfo(orderId: string, amount: number) {
  try {
    const { data } = await instance.post<APIResponse>(`/payments/temporary`, { orderId, amount });
    if (data.errorCode !== 'OK') {
      console.error('[postOrderInfo] API error code:', data.errorCode);
      return false;
    }
    return true;
  } catch (err) {
    if (isAxiosError(err)) {
      if (err.response) {
        console.error('[postOrderInfo] API error code:', err.response.data.errorCode);
      } else {
        console.error('[postOrderInfo] Axios error message:', err.message);
      }
    } else {
      console.error('[postOrderInfo] Unknown error', err);
    }
    return false;
  }
}

export const postPaymentConfirmAtom = atomWithMutation(() => ({
  mutationFn: async ({ paymentKey, orderId, amount }: { paymentKey: string; orderId: string; amount: number }) => {
    const isSuccess = await postPaymentConfirm(paymentKey, orderId, amount);
    return isSuccess;
  },
}));
async function postPaymentConfirm(paymentKey: string, orderId: string, amount: number) {
  try {
    const { data } = await instance.post<APIResponse>(`/payments/confirm`, { paymentKey, orderId, amount });
    if (data.errorCode !== 'OK') {
      console.error('[postPaymentConfirm] API error code:', data.errorCode);
      return false;
    }
    return true;
  } catch (err) {
    if (isAxiosError(err)) {
      if (err.response) {
        console.error('[postPaymentConfirm] API error code:', err.response.data.errorCode);
      } else {
        console.error('[postPaymentConfirm] Axios error message:', err.message);
      }
    } else {
      console.error('[postPaymentConfirm] Unknown error', err);
    }
    return false;
  }
}
